<!--Mobile Header-->
<fgb-page-header [pageTitle]="'challenges.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<div class="container pt-lg-4">
  <fgbcl-badge-achieved></fgbcl-badge-achieved>
</div>

<div class="pt-4">
  <fgbcl-scorecard-list-view [icon]="'chevron_right'" [showPlaceholder]="true"></fgbcl-scorecard-list-view>
</div>
